import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { features } from "../../../../features";
import { EventCard } from "../../EventCard";
import { pushEventAction } from "../../EventUtils";
const React = require("react");
// Re-exported: EventOverviewWidget and AanZet tippedActivities import these from here
export { nextEvent, nextNestedEvent, scrollTargetId } from "../../EventCard";
export const activityHeaderId = "activities__header";
export const EventOverviewResultBlock = (props)=>props.events.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h4", {
                children: props.label
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "a-content__list",
                children: props.events.map((event)=>/*#__PURE__*/ _createElement(EventOverviewResultItem, {
                        event,
                        detailLinkSearch: props.detailLinkSearch,
                        key: `event__${event.Id}`
                    }))
            })
        ]
    });
export const EventOverviewResultItem = (props)=>{
    const push = pushEventAction();
    const config = features().events;
    if (config == 'off') return null;
    const { event, detailLinkSearch } = props;
    return /*#__PURE__*/ _jsx(EventCard, {
        event: event,
        linkUrl: `${config.prefix}/${event.TargetId}${detailLinkSearch || ''}`,
        onNavigate: ()=>push('Navigate from overview to details', event.TargetId)
    });
};
